import { ValidatorFn, FormGroup, ValidationErrors } from '@angular/forms';

export function skinTestResultValidator(control: FormGroup): ValidationErrors | null {
    const lastSkinTestDate = control.value.lastSkinTestDate;
    const skinTestPositive = control.value.skinTestPositive;
    return lastSkinTestDate != null && skinTestPositive == null ? { "skinTestResultMissing": true } : null;
}

